import './aboutBook.css';

function AboutBook({ book }) {
  return (
    <section className="about-book">
      <div className="about-title">
        <h2>About {book.title}</h2>
      </div>

      <div className="about-content">
        {/* Left: Sticky Cover */}
        <div className="book-cover-wrapper">
          <img src={book.cover} alt={`${book.title} Book Cover`} className="book-cover" />
        </div>

        {/* Right: Description + Chapters */}
        <div className="book-details">
          {/* Introduction */}
          <div className="section">
            <h3 className="section-title">Introduction</h3>
            <p className="section-subtitle">{book.subtitle}</p>
            <p className="section-description">{book.intro}</p>
          </div>

          {/* Chapters */}
          {book.chapters.map((chapter, index) => (
            <div className="section chapter" key={index}>
              <h3 className="section-title">Chapter {index + 1}</h3>
              {chapter.subtitle && (
                <p className="section-subtitle">{chapter.subtitle}</p>
              )}
              <p className="section-description">{chapter.description || chapter.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutBook;